"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesCompanyAcceptTransfers = void 0;
function doesCompanyAcceptTransfers(company) {
    if (!company.users)
        return false;
    return company.users.some(user => user.can_receive_call_transfer);
}
exports.doesCompanyAcceptTransfers = doesCompanyAcceptTransfers;
